<div class="relative flex flex-col py-2 px-1 w-[356px] sm:w-[500px] lg:w-[780px] max-w-full">

  <div class="flex items-start justify-between">
    <h2 mat-dialog-title
      class="m-0 text-lg md:text-xl font-semibold text-slate-800 pr-4 md:pr-8 flex-1 break-words whitespace-normal leading-snug">
      Hello {{ companyName }}</h2>
    <button mat-icon-button
      class="close-btn shrink-0 w-9 h-10 leading-9 text-gray-400 hover:text-gray-700 bg-transparent mr-2"
      (click)="onGotItClick()" aria-label="Close dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="!pb-3 max-h-[65vh]">
    <div class="mb-4 lg:mb-6">
      <h2 *ngIf="companyName" class="font-semibold text-slate-800 m-0 mb-1.5 text-[20px]">{{ dialogTitle }},</h2>
      <p class="text-[14.5px] leading-relaxed text-slate-600 m-0">{{ introText }}</p>
    </div>

    <div class="flex flex-col gap-3 mb-6">
      <div class="flex items-start gap-4" *ngFor="let feature of features">
        <div
          class="feature-icon flex items-center justify-center w-9 h-9 rounded-lg bg-[#5459D1]/10 text-[#5459D1] shrink-0">
          <mat-icon>{{ feature.icon }}</mat-icon>
        </div>
        <div class="flex flex-col">
          <h4 class="m-0 mb-0.5 text-sm font-semibold text-slate-800">{{ feature.title }}</h4>
          <p class="m-0 text-[13px] text-slate-500 leading-snug">{{ feature.description }}</p>
        </div>
      </div>
    </div>

    <div class="flex items-start gap-3 py-3 px-4 bg-yellow-50 rounded-lg mb-5 border-l-[3px] border-yellow-400">
      <mat-icon class="text-yellow-600 text-[18px] w-auto h-auto !overflow-clip">info</mat-icon>
      <p class="m-0 text-[12.5px] text-yellow-800 italic leading-snug">{{ webcamNotice }}</p>
    </div>

    <div class="text-center mt-3 mb-1">
      <p class="m-0 text-[13px] text-slate-500 leading-relaxed">
        Manage your plan anytime from <a routerLink="/billings" (click)="onGotItClick()"
          class="text-[#5459D1] font-semibold hover:underline">Billing & Plans</a>.
      </p>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="center" class="py-2 m-0 flex gap-3 justify-center">
    <button mat-raised-button color="primary"
      class="min-w-[120px] font-medium rounded-md shadow-none bg-[#5459D1] hover:bg-[#4347A8] text-white"
      (click)="onGotItClick()">
      {{ primaryButtonText }}
    </button>
    <button mat-stroked-button
      class="min-w-[120px] font-medium rounded-md shadow-none text-slate-700 border-slate-300 hover:bg-slate-50"
      (click)="onContactSupportClick()">
      Contact Support
    </button>
  </mat-dialog-actions>
</div>